



















































































import mixins from 'vue-typed-mixins';
import { Section } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Section,
    },
  },
});
